import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _TAB_TYPE_VS_ANTD_PRO;
export var TAB_TYPE = {
  LINE_VARIANT_GENERAL: 'LINE_VARIANT_GENERAL',
  CARD_VARIANT_GROW: 'CARD_VARIANT_GROW',
  // uses flex-grow to occupy the entire area with tabs
  CARD_VARIANT_GENERAL: 'CARD_VARIANT_GENERAL' // tekion's flavor of card type
};

export var TAB_TYPE_VS_ANTD_PROPS = (_TAB_TYPE_VS_ANTD_PRO = {}, _defineProperty(_TAB_TYPE_VS_ANTD_PRO, TAB_TYPE.CARD_VARIANT_GROW, {
  type: 'card',
  className: 'card-tabs-grow'
}), _defineProperty(_TAB_TYPE_VS_ANTD_PRO, TAB_TYPE.CARD_VARIANT_GENERAL, {
  type: 'card',
  className: 'card-tabs-general'
}), _defineProperty(_TAB_TYPE_VS_ANTD_PRO, TAB_TYPE.LINE_VARIANT_GENERAL, {
  type: 'line',
  className: 'line-tabs-general'
}), _TAB_TYPE_VS_ANTD_PRO);
export var DEFAULT_TAB_HEIGHT = 60;